import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { finalize, tap } from 'rxjs/operators';
import { NotificationsService } from 'angular2-notifications';
import { HttpActivityService } from './core/services/http-activity.service';

export const interceptFn: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const notifications = inject(NotificationsService);
  const httpActivity = inject(HttpActivityService);

  // Check if user is logged in and JWT token exists
  const isLoggedIn = localStorage.getItem('isLoggedin') === 'true';
  const token = localStorage.getItem('jwtToken');

  if (isLoggedIn && token) {
    // Clone the request and add the Authorization header
    console.log('Interceptor :  Setting the JWT token:', token);
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  // Counted here rather than in each screen: this is the one place every call passes through, on
  // the success path and the error path alike, so the count cannot be left standing by a subscribe
  // that only handles `next`. appBusy reads it to spin the button that started the call.
  httpActivity.started();

  return next(req).pipe(
    finalize(() => httpActivity.finished()),
    tap({
      next: (event) => {
        if (event.type === 4) { // 4 is the HttpResponse event type
          console.log(' Interceptor : Success response----', event.status);
        }
      },
      error: (error) => {
        console.log('Interceptor :  Error response----', error);

        if (error.status === 401) {
          localStorage.setItem('isLoggedin', 'false');
          localStorage.removeItem('isAdmin');
          localStorage.removeItem('user');
          localStorage.removeItem('jwtToken');
          sessionStorage.removeItem('dashboardLoaded');
          sessionStorage.removeItem('loginPageRefreshed');
          notifications.error('Error', 'Authentication failed. Access denied !!!');
          router.navigateByUrl('/auth/login');
        } else if (error.status === 403) {
          localStorage.setItem('isLoggedin', 'false');
          localStorage.removeItem('isAdmin');
          localStorage.removeItem('user');
          localStorage.removeItem('jwtToken');
          sessionStorage.removeItem('dashboardLoaded');
          sessionStorage.removeItem('loginPageRefreshed');
          if (error.error != null) {
            notifications.error('Error', 'Access denied due to insufficient permissions !!!');
          }
        }
      },
    })
  );
};
